"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboundStxTransferToJSON = exports.InboundStxTransferFromJSONTyped = exports.InboundStxTransferFromJSON = exports.InboundStxTransferTransferTypeEnum = void 0;
/**
* @export
* @enum {string}
*/
var InboundStxTransferTransferTypeEnum;
(function (InboundStxTransferTransferTypeEnum) {
    InboundStxTransferTransferTypeEnum["bulk_send"] = "bulk-send";
    InboundStxTransferTransferTypeEnum["stx_transfer"] = "stx-transfer";
})(InboundStxTransferTransferTypeEnum = exports.InboundStxTransferTransferTypeEnum || (exports.InboundStxTransferTransferTypeEnum = {}));
function InboundStxTransferFromJSON(json) {
    return InboundStxTransferFromJSONTyped(json, false);
}
exports.InboundStxTransferFromJSON = InboundStxTransferFromJSON;
function InboundStxTransferFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sender': json['sender'],
        'amount': json['amount'],
        'memo': json['memo'],
        'block_height': json['block_height'],
        'tx_id': json['tx_id'],
        'transfer_type': json['transfer_type'],
        'tx_index': json['tx_index'],
    };
}
exports.InboundStxTransferFromJSONTyped = InboundStxTransferFromJSONTyped;
function InboundStxTransferToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sender': value.sender,
        'amount': value.amount,
        'memo': value.memo,
        'block_height': value.block_height,
        'tx_id': value.tx_id,
        'transfer_type': value.transfer_type,
        'tx_index': value.tx_index,
    };
}
exports.InboundStxTransferToJSON = InboundStxTransferToJSON;
//# sourceMappingURL=InboundStxTransfer.js.map